module.exports = __webpack_public_path__ + "static/img/telemetry.641426b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telemetry.png
// module id = lXvy
// module chunks = 1